<template>
  <h1 class="header" :style="headerElStyles" v-html="header.text"></h1>
</template>

<script>
export default {
  name: "CoverUIHeader",
  props: {
    header: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    headerElStyles() {
      const { isTextInCaps, textColor } = this.header;

      // direct styles
      const styles = {
        textTransform: isTextInCaps ? "uppercase" : "initial",
        color: textColor.value,
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-style: normal;
  hyphens: auto;
  overflow-wrap: anywhere;

  @include font-family("heading");
  @include scale-fonts("heading-1");
  @include setup-richtext();
}
</style>
